export default "__VITE_ASSET__DZVzkVXm__"